import React, { useState } from "react";
import { Container, Card, Row, Col, ListGroup } from "react-bootstrap";
import "react-bootstrap-icons";
import { Eye, EyeSlash, Person, PersonSquare } from "react-bootstrap-icons";
import "./CSSStylesheet.css";

function AccountHolders({ Account_Holder }) {
  const [showID, setShowID] = useState(false);

  return (
    <div className="mb-4 loan-details-borrower-section h-100">
      <Card
        // style={{ backgroundColor: "white" }}
        className="border border-primary h-100"
      >
        <Card.Body className="p-0">
          <Row>
            <Col>
              <Card.Header className="fw-bold">Account Holders</Card.Header>
            </Col>
          </Row>
          <Row className="d-flex align-items-center py-5">
            <Col xs="auto">
              <ListGroup.Item style={{ border: 0, textAlign: "center" }}>
                <PersonSquare size={35} />
              </ListGroup.Item>
            </Col>
            <Col>
              <Card.Subtitle className="mb-1 mt-3 ">
                {Account_Holder?.[0]?.name}
              </Card.Subtitle>
              <Card.Text>{Account_Holder?.[0]?.main_contact}</Card.Text>
            </Col>
          </Row>
          <Row>
            <Col
            // style={{ maxHeight: "337px", overflow: "auto" }}
            >
              <ListGroup variant="flush" className="gap-4">
                <ListGroup.Item style={{ border: 0 }}>
                  <strong>Address :</strong>
                  {Account_Holder?.[0]?.address}
                </ListGroup.Item>
                <ListGroup.Item style={{ border: 0 }}>
                  <strong>Email :</strong>
                  {Account_Holder?.[0]?.email?.replaceAll(";", " ")}
                </ListGroup.Item>
                <ListGroup.Item style={{ border: 0 }}>
                  <strong>Mobile :</strong>
                  {Account_Holder?.[0]?.home_phone || " - "}
                </ListGroup.Item>
                <ListGroup.Item style={{ border: 0 }}>
                  <strong>Home Phone :</strong>
                  {Account_Holder?.[0]?.work_phone || " - "}
                </ListGroup.Item>
                <ListGroup.Item style={{ border: 0 }}>
                  <strong>Work Phone :</strong>
                  {Account_Holder?.[0]?.mobile_phone || " - "}
                </ListGroup.Item>
                <ListGroup.Item style={{ border: 0 }}>
                  <strong>Tax ID (last 4 digits) :</strong>

                  <div className="d-flex align-items-center gap-5">
                    <div>
                      {showID ? Account_Holder?.[0]?.tax_id || "" : "****"}{" "}
                    </div>
                    <div>
                      <button
                        className="btn btn-primary text-white"
                        onClick={() => setShowID((prev) => !prev)}
                      >
                        {showID ? <Eye size={20} /> : <EyeSlash size={20} />}
                      </button>
                    </div>
                  </div>
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default AccountHolders;
